export function frameRateLimited (cb, context = null) {
  let ready = true
  function wrapped () {
    if (!ready) return
    ready = false
    window.requestAnimationFrame(() => {
      cb.call(this)
      ready = true
    })
  }
  return context ? wrapped.bind(context) : wrapped
}
